// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"21":"c2db6c69","260":"8b311823","450":"99464763"}[chunkId] + ".css";
};